<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="d-flex flex-row title-line">
  <well-page-title title=" {{'company.subscription-type.list-title' | translate}}"></well-page-title>

  <div class="button-mt mr-md" style="display: flex">
    <button pButton type="button" class="p-button-outlined"
            [label]="'company.subscription-type.add' | translate"
            icon="ui-icon-add" (click)="addNew()" data-testid="add-new-btn"></button>
  </div>
</div>

<div class="d-flex mx mt-4 align-items-center">
  <h3>{{'company.subscription-type.select-company-type' | translate}}</h3>
  <p-select [options]="companyTypesSelectItems | addEmptySelectItemOption: ('company.utils.all' | translate)"
              [(ngModel)]="selectedCompanyType"
              class='ml-3'
              optionLabel='label'
              [editable]="true"
              (onChange)="filterSubscriptions($event.value)" data-testid="selected-company-type-select">
  </p-select>
</div>

<div class="container p">

  <ng-container *ngIf="listResource | async; let list">

    <div class="row ">
      <div class="col-12 col-sm-6 col-md-4" *ngFor="let subscription of list.data;let first = first">

        <well-subscription-card-view-wrapper [subscription]="subscription">
          <div class="buttons">

            <button pButton [label]="'company.utils.edit' | translate" type="submit"
                    (click)="onEdit(subscription.uuid)" data-testid="on-edit-btn"></button>
          </div>
        </well-subscription-card-view-wrapper>
      </div>
    </div>
  </ng-container>


</div>


